import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { services, Insertservices } from "../../apis/api/DataApi";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import Lodderr from "../../components/Lodder/Lodder";
import { ProfileGet } from "../../apis/api/ProfileApi";
import { toast } from "react-toastify";

const EditServicesModal = ({ show, handleClose, servicesData }) => {
  const dispatch = useDispatch();
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedSpecialServices, setSelectedSpecialServices] = useState([]);
 const userId = Cookies.get("userID");
  const company_id = Cookies.get("company_id");
  const { loading, Services } = useSelector((state) => state.DataSlice);

  useEffect(() => {
    dispatch(services());
  }, [dispatch]);

  
  useEffect(() => {
    if (servicesData && Services.length > 0) {
      const preselected = servicesData.map((service) => {
        const match = Services.find(
          (opt) => opt.value.split(":")[0] === service.id.toString()
        );
        return match;
      }).filter(Boolean);
      setSelectedServices(preselected);
    }
  }, [servicesData, Services]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const company_id = Cookies.get("company_id");

    const formData = {
      companyId: company_id,
      selectedServices: selectedServices.map((item) =>
        item.value.split(":")[0]
      ),
      selectedSpecialServices: selectedSpecialServices.map((item) =>
        item.value.split(":")[0]
      ),
    };

   const response= await dispatch(Insertservices(formData));
   if(response.payload.status === "success"){
    toast.success("services inserted succesfully")
    dispatch(ProfileGet({ userId, company_id }))
   }
  
  };

  return (
    <>
      {loading && <Lodderr />}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Services</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={handleSubmit}
            className="p-4 border rounded shadow bg-light"
          >
            <div className="row">
              <div className="col-md-12 mb-3">
                <Form.Group>
                  <Form.Label>Services</Form.Label>
                  <Select
                    isMulti
                    options={Services}
                    value={selectedServices}
                    onChange={setSelectedServices}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select services..."
                  />
                </Form.Group>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
         
          <Button variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditServicesModal;
